import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    // bonusReportKey,
    tamLessonsKey,
    majorIndexBreadthKey,
    positionSizeCalculatorKey,
    relativeStrengthMatrixKey,
    sectorsKey,
    tamProductKey,
    tamVimeoKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = tamLessonsKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: tamProductKey
}

const productActionTopicKeys = [
    // bonusReportKey,
    tamVimeoKey,
    tamLessonsKey,
    majorIndexBreadthKey,
    sectorsKey,
    positionSizeCalculatorKey,
    relativeStrengthMatrixKey
];

export function useTechnicalAnalysisMillionaire() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( tamProductKey, productActionTopicKeys );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        selectedView
    }
}
